import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { forkJoin } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CommonDataService } from '../../services/common-data.service';
import { GraphqlService } from '../../services/graphql.service';

@Component({
  selector: 'app-what-links-here',
  templateUrl: './what-links-here.component.html'
})
export class WhatLinksHereComponent implements OnInit {

  @Output() myEvent = new EventEmitter<string>();

  urlLink: string;
  what_links_header: string;
  what_links_body: string;
  what_links_source: any = [];

  links_to;
  crumbData: any = [];
  outcomeStatus: boolean = false;
  invalidbreadcrumb: boolean = false;

  whatLinksHereObject: {
    id: string,
    breadcrumbPath: string,
    subsections: {
      subsectionTitle: string,
      subsectionLinks: {
        linkTitle: string,
        paragraphNumber: string,
        publicationId: string,
        topicId: string
      }[]
    }[]
  }[] = [];

  constructor(private graphQlService: GraphqlService, private router: Router, private commonDataService: CommonDataService) { }

  ngOnInit(): void {
    this.outcomeStatus = false;
    this.urlLink = this.router.url;
    this.crumbData = this.commonDataService.navDataContentPage.getValue();
    if (this.crumbData.length != 0) {
      this.getWhatLinksHereLables();
    }
    else {
      this.invalidbreadcrumb = true;
    }
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd)
      )
      .subscribe(() => {
        this.myEvent.emit();
        this.commonDataService.parentComponentDetails.next([]);
      })
  }
  linkRecord;
  GlossaryRecords = [];
  NonGlossaryRecords = [];
  getWhatLinksHereLables() {
    this.commonDataService.showLoader.next(true);
    forkJoin([
      this.graphQlService.getWhatLinksHereLabels(),
      // this.graphQlService.getWhatLinksHereContent()
      this.graphQlService.getWhatLinksHereContent(this.crumbData[0], this.crumbData[1], this.crumbData[2], this.crumbData[3], this.crumbData[4])
    ]).subscribe(([WhatLinkslabels, WhatLinksdata]) => {
      //labels
      let labels = WhatLinkslabels.content.data.labels;
      this.what_links_header = labels.filter(x => x.key === "what_links_header").map(y => y.value);
      this.what_links_body = labels.filter(x => x.key === "what_links_subtext").map(y => y.value);
      this.links_to = labels.filter(x => x.key === "links_to").map(y => y.value);
      //data
      this.what_links_source = WhatLinksdata;
      this.GlossaryRecords = this.what_links_source?.filter(x => x.source.isGlossary == true);
      this.NonGlossaryRecords = this.what_links_source?.filter(x => x.source.isGlossary == false);

      let groups = {};
      for (let i = 0; i < this.GlossaryRecords.length; i++) {
        let groupName = this.GlossaryRecords[i].source.targetParaNumber == null ? "" : this.GlossaryRecords[i].source.targetParaNumber;
        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push(this.GlossaryRecords[i].source);
      }
      for (let i = 0; i < this.NonGlossaryRecords.length; i++) {
        let groupName = this.NonGlossaryRecords[i].source.targetParaNumber == null ? "" : this.NonGlossaryRecords[i].source.targetParaNumber;
        if (!groups[groupName]) {
          groups[groupName] = [];
        }
        groups[groupName].push(this.NonGlossaryRecords[i].source);
      }
      this.linkRecord = [];
      for (let groupName in groups) {
        this.linkRecord.push({ group: groupName, source: groups[groupName] });
      }
      this.linkRecord.sort((first, second) => this.sortAlphaNum(first.group, second.group) > 0 ? 1 : -1);
      //this.linkNonGlossaryRecord.sort((first, second) => this.sortAlphaNum(first.group, second.group) ? -1 : 1);
      // let source = WhatLinksdata.hits.hitsData[0].source;
      // this.whatLinksHereObject.push({
      //   id: source.id,
      //   breadcrumbPath: source.breadcrumbPath,
      //   subsections: source.subsections
      // });
      this.outcomeStatus = true;
      this.commonDataService.showLoader.next(false);
    });
  }

  checkNumber(num) {
    if (num == "1" || num == "2" || num == "3" || num == "4" || num == "5" || num == "6" || num == "7" || num == "8" || num == "9" || num == "0") { return true; }
    else { return false; }
  }

  onlyLetters(str) {
    return /^[a-zA-Z\s]+$/.test(str);
  }

  getNumber(str) { return str.replace(/\D/g, ""); }
  getAlphabets(str) { return str.replace(/[^A-Za-z]/g, ''); }

  sortAlphaNum(a, b) {
    let compartorResult = 0;
    a = a.replace(/\s\s+/g, ' ');
    b = b.replace(/\s\s+/g, ' ');
    if (this.checkNumber(a.charAt(0)) && this.checkNumber(b.charAt(0))) {
      if (a.includes(".") && b.includes(".")) {
        if (a.split(".")[0] == b.split(".")[0]) {
          if (a.split(".")[1] == b.split(".")[1]) {
            if (a.split(".").length > 2 && b.split(".").length > 2) {
              if (a.split(".")[2] == b.split(".")[2]) {
                if (a.split(".").length > 3 && b.split(".").length > 3) {
                  if (a.split(".")[3] == b.split(".")[3]) {
                    compartorResult = 0;
                  }
                  else { compartorResult = a.split(".")[3].split(" ")[0] - b.split(".")[3].split(" ")[0] > 0 ? 1 : (a.split(".")[3].split(" ")[0] == b.split(".")[3].split(" ")[0] ? 0 : -1); }
                }
                else if (a.split(".").length > 3 && b.split(".").length < 3) {
                  compartorResult = 1;
                }
                else if (a.split(".").length < 3 && b.split(".").length > 3) {
                  compartorResult = -1;
                }
                else {
                  compartorResult = 0;
                }
              }
              else { compartorResult = a.split(".")[2].split(" ")[0] - b.split(".")[2].split(" ")[0] > 0 ? 1 : (a.split(".")[2].split(" ")[0] == b.split(".")[2].split(" ")[0] ? 0 : -1); }
            }
            else if (a.split(".").length > 2 && b.split(".").length < 2) {
              compartorResult = 1;
            }
            else if (a.split(".").length < 2 && b.split(".").length > 2) {
              compartorResult = -1;
            }
            else {
              compartorResult = 0;
            }
          }
          else { compartorResult = a.split(".")[1].split(" ")[0] - b.split(".")[1].split(" ")[0] > 0 ? 1 : ((a.split(".")[1].split(" ")[0] == b.split(".")[1].split(" ")[0]) ? 0 : -1); }
        }
        else { compartorResult = a.split(".")[0] - b.split(".")[0] > 0 ? 1 : ((a.split(".")[0] == b.split(".")[0]) ? 0 : -1); }
      }
      else if (a.includes(".") && !b.includes(".")) {
        if (a.split(".")[0] == b.split(" ")[0]) { compartorResult = 1; }
        else { compartorResult = this.getNumber(a.split(".")[0]) - this.getNumber(b.split(" ")[0]); }
      }
      else if (!a.includes(".") && b.includes(".")) {
        if (a.split(" ")[0] == b.split(".")[0]) { compartorResult = 1; }
        else {
          compartorResult = this.getNumber(a.split(" ")[0]) - this.getNumber(b.split(".")[0]);
        }
      }
      else { compartorResult = a - b > 0 ? 1 : -1; }
    }
    else if (a.split(" ")[0].includes("Appendix B") && b.split(" ")[0].includes("Appendix B")) {
      if (a.split("Appendix B")[1].split("-").length > 1 && b.split("Appendix B")[1].split("-").length > 1) {
        if (a.split("Appendix B")[1].split("-")[0] == b.split("Appendix B")[1].split("-")[0]) {
          if (this.getNumber(a.split(" ")[1].split("-")[1].split(":")[0]) == this.getNumber(b.split(" ")[1].split("-")[1].split(":")[0]))
          {
            compartorResult = this.getAlphabets(a.split(" ")[1].split("-")[1].split(":")[0]) > this.getAlphabets(b.split(" ")[1].split("-")[1].split(":")[0]) ? 1: -1;
          }
          else {
            compartorResult = this.getNumber(a.split(" ")[1].split("-")[1].split(":")[0]) - this.getNumber(b.split(" ")[1].split("-")[1].split(":")[0]) > 0 ? 1 : -1;
          }
        }
        else { compartorResult = a.split("Appendix B")[1].split("-")[0] - b.split("Appendix B")[1].split("-")[0] > 0 ? 1 : -1; }
      }
      else if (a.split("Appendix B")[1].split("-").length > 1 && b.split("Appendix B")[1].split("-").length <= 1) {
        compartorResult = 1;
      }
      else if (a.split("Appendix B")[1].split("-").length <= 1 && b.split("Appendix B")[1].split("-").length > 1) {
        compartorResult = -1;
      }
    }
    else if (a.split(" ")[0].includes("Illustration") && b.split(" ")[0].includes("Illustration")
      || a.split(" ")[0].includes("Exercise") && b.split(" ")[0].includes("Exercise")) {
      if (a.split(" ").length > 1 && b.split(" ").length > 1) {
        if (this.getNumber(a.split(" ")[1].split("—")[0]) == this.getNumber(b.split(" ")[1].split("—")[0])) {
          compartorResult = this.getAlphabets(a.split(" ")[1].split("—")[0]) > this.getAlphabets(b.split(" ")[1].split("—")[0]) ? 1 : -1;
        }
        else {
          compartorResult = this.getNumber(a.split(" ")[1].split("—")[0]) - this.getNumber(b.split(" ")[1].split("—")[0]) > 0 ? 1 : -1;
        }
      }
      else if (a.split(" ").length > 1 && b.split(" ").length <= 1) {
        compartorResult = 1;
      }
      else if (a.split(" ").length <= 1 && b.split(" ").length > 1) {
        compartorResult = -1;
      }
    }
    else if (a.split(" ")[0].includes("Exhibit") && b.split(" ")[0].includes("Exhibit")) {
      if (a.split(" ").length > 1 && b.split(" ").length > 1) {
        if (a.split(" ")[1].includes("—") && b.split(" ")[1].includes("—")) {
          if (this.getNumber(a.split(" ")[1].split("—")[0]) == this.getNumber(b.split(" ")[1].split("—")[0])) {
            compartorResult = this.getAlphabets(a.split(" ")[1].split("—")[0]) > this.getAlphabets(b.split(" ")[1].split("—")[0]) ? 1 : -1;
          }
          else {
            compartorResult = this.getNumber(a.split(" ")[1].split("—")[0]) - this.getNumber(b.split(" ")[1].split("—")[0]) > 0 ? 1 : -1;
          }
        }
        else if (!a.split(" ")[1].includes("—") && b.split(" ")[1].includes("—")) {
          if (this.getNumber(a.split(" ")[1]) == this.getNumber(b.split(" ")[1].split("—")[0])) {
            compartorResult = this.getAlphabets(a.split(" ")[1]) > this.getAlphabets(b.split(" ")[1].split("—")[0]) ? 1 : -1;
          }
          else {
            compartorResult = this.getNumber(a.split(" ")[1]) - this.getNumber(b.split(" ")[1].split("—")[0]) > 0 ? 1 : -1;
          }
        }
        else if (a.split(" ")[1].includes("—") && !b.split(" ")[1].includes("—")) {
          if (this.getNumber(a.split(" ")[1].split("—")[0]) == this.getNumber(b.split(" ")[1])) {
            compartorResult = this.getAlphabets(a.split(" ")[1].split("—")[0]) > this.getAlphabets(b.split(" ")[1]) ? 1 : -1;
          }
          else {
            compartorResult = this.getNumber(a.split(" ")[1].split("—")[0]) - this.getNumber(b.split(" ")[1]) > 0 ? 1 : -1;
          }
        }
        else {
          if (this.getNumber(a.split(" ")[1]) == this.getNumber(b.split(" ")[1])) {
            compartorResult = this.getAlphabets(a.split(" ")[1]) > this.getAlphabets(b.split(" ")[1]) ? 1 : -1;
          }
          else {
            compartorResult = this.getNumber(a.split(" ")[1]) - this.getNumber(b.split(" ")[1]) > 0 ? 1 : -1;
          }
        }
      }
      else if (a.split(" ").length > 1 && b.split(" ").length <= 1) {
        compartorResult = 1;
      }
      else if (a.split(" ").length <= 1 && b.split(" ").length > 1) {
        compartorResult = -1;
      }
    }
    else if (!this.checkNumber(a.charAt(0)) && this.checkNumber(b.charAt(0))) {
      compartorResult = 1;
    }
    else if (this.checkNumber(a.charAt(0)) && !this.checkNumber(b.charAt(0))) {
      compartorResult = -1;
    }
    else {
      compartorResult = a > b ? 1 : -1;
    }
    return compartorResult;
  }

  gotoContent(path: any, event) {
    event.preventDefault();
    let breadcrumbPath = path;
    this.router.navigateByUrl(path.publication_Id + "/" + path.sourceTopicId + "/" + path.sourceParagraphId, {//2011223/2147474721
      state: {
        backLabel: breadcrumbPath,
        backUrl: this.urlLink
      }
    });
    this.myEvent.emit();
  }
  onRightClick(path, event) {
    let url = path.publication_Id + "/" + path.sourceTopicId + "/" + path.sourceParagraphId;
    if (event.target.tagName.toLowerCase() != 'a' && event.target.parentNode.tagName.toLowerCase() == 'a') {
      event.target.parentNode.setAttribute('href', url);
    }
    else if (event.target.tagName.toLowerCase() == 'a' && event.target.parentNode.tagName.toLowerCase() != 'a') {
      event.target.setAttribute('href', url);
    }

  }

  OpenInlineGlossary(event) {
    let id = event.target.id == "" ? event.target.parentNode.id : event.target.id;

    this.commonDataService.rightOverlayOption.next("inline-glossary");
    this.commonDataService.rightPanelWidth.next("rightOverLay_small");
    this.commonDataService.glossaryTermId.next(id);
    this.commonDataService.showRightPanel.next(true);

    let obj = this.commonDataService.parentComponentDetails.getValue();
    obj.push({
      source: "What Links Here",
      data: this.crumbData,
      panelWidth: "rightOverlay_large"
    });


    this.commonDataService.parentComponentDetails.next(obj);
    // this.commonDataService.
  }
}
